<template>
    <div>
        <q-stepper v-model="currentStep" ref="stepper">
            <q-step v-if="enablePhoneValidation" :title="$T('Phone Validation')" name="phone_validation">
                <phone-validation></phone-validation>
            </q-step>
            <q-step :title="$T('Consumer Eligibility')" name="consumer_eligibility" disable>
                <consumer-eligibility></consumer-eligibility>
            </q-step>
            <q-step :title="$T('Order')" name="order">
                <order-form :mockData="mockData"></order-form>
            </q-step>
        </q-stepper>
    </div>
</template>

<script>

    import OrderForm from "./orderForm"
    import PhoneValidation from "./phoneValidation"
    import consumerEligibility from "./consumerEligibility"
    import { EventBus } from '../../plugins/event-bus'

    export default {
        name: "orderStepper",

        components: {
            PhoneValidation,
            consumerEligibility,
            OrderForm
        },

        props: {
            mockData: Object
        },

        data() {
            return {
                enablePhoneValidation: this.mockData.enablePhoneValidation,
            }
        },
        computed: {
            currentStep() {
                return this.enablePhoneValidation ? 'phone_validation' : 'consumer_eligibility';
            },
        },
        mounted() {
            EventBus.$on('nextStep', (phone_number, phone_prefix) => {
                this.mockData.phone_number = phone_number
                this.mockData.phone_prefix = phone_prefix
                this.$refs.stepper.next()

            });
            EventBus.$on('isEligible', (phone, phone_prefix, dni, email) => {
                this.mockData.phone_number = phone
                this.mockData.phone_prefix = phone_prefix
                this.mockData.dni = dni
                this.mockData.email = email
                this.$refs.stepper.next()

            });
            
            EventBus.$on('resetStepper', (step) => {
                this.$refs.stepper.goToStep(step)
                
                this.mockData.phone_number = ''
                this.mockData.phone_prefix = ''
                this.mockData.dni = ''
                this.mockData.email = ''
            });
        },
        
        beforeDestroy() {
            EventBus.$off('nextStep')
            EventBus.$off('isEligible')
            EventBus.$off('resetStepper')
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/lending-point/orderStepper.vue